import { useState } from "react";

import Dropdown from "../../common/molecules/Dropdown";

const options = [
  { key: "THIS_WEEK", value: "Semana actual" },
  { key: "THIS_MONTH", value: "Mes Actual" },
  { key: "THIS_YEAR", value: "Año Actual" },
];

const BaseFiltersSelector = ({ onChange }) => {
  const [loading, setLoading] = useState(false);

  const [initialOption, setInitialOption] = useState(options[0]);

  const handleClick = (option) => {
    onChange(option.key);
  };

  return (
    <Dropdown
      options={options}
      fullWidth={true}
      hasIcon={false}
      onClick={handleClick}
      loading={loading}
      defaultOption={initialOption}
      responsive={true}
    />
  );
};

export default BaseFiltersSelector;
